export default __webpack_public_path__ + "static/media/minusSkip.a21558f9.svg";